import styled from "styled-components";

export const ModalBackground = styled.div`

    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    top: 0;

    background-color: rgba(0,0,0,0.5);
`

export const StyledModal = styled.div`

    width: 396px;
    min-height: 300px;

    margin: 20px;

    max-width: 100vw;

    background-color: var(--color-grey-3);

    header{
        padding: 20px 15px;
        width: 100%;

        display: flex;
        justify-content: space-between;
        align-items: center;

        background-color: var(--color-grey-2);
    }

    header button{
        background-color: transparent;
        border: none;
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;

        color: var(--color-grey-1);
    }

    header h2{
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        color: var(--color-grey-0);
    }

    form{
        padding: 32px 22px;
        
        display: flex;
        flex-direction: column;

        gap: 22px;
    }
`